import { RouteComponentProps } from 'react-router-dom'
import { SELECT_AP_PARCEL } from '../components/aerialphotography-components/ap.slice'
import { LocationData } from '../components/map/MapComponent'
import { PlanningAppData } from '../components/planning-components/slice'
import { RootState } from './store'
import { Action, PayloadAction } from './types'

// Action Types

export const FORCE_RECAPTCHA = 'FORCE_RECAPTCHA'
export const HIDE_RECAPTCHA = 'HIDE_RECAPTCHA'
export const ACCEPT_DISCLAIMER = 'ACCEPT_DISCLAIMER'
export const RECAPTCHA_LOADED = 'RECAPTCHA_LOADED'
export const SELECT_PARCEL = 'SELECT_PARCEL'

// Selectors

export const getDisclaimerBase = (state: RootState) => {
  return state.disclaimer
}

export const getDisclaimerAccepted = (state: RootState) => {
  return getDisclaimerBase(state).accepted
}

export const getRecaptcha = (state: RootState) => {
  return state.recaptcha
}

export const getRecaptchaLoaded = (state: RootState) => {
  return getRecaptcha(state).recaptchaLoaded
}

export const getSelectedParcel = (state: RootState) => {
  return state.selectedParcel
}

// Actions

export const forceManualRecaptcha = (action: RecaptchaAction<RecaptchaPayload>) => {
  return {
    type: FORCE_RECAPTCHA,
    payload: action,
  }
}
export const hideRecaptcha = () => ({
  type: HIDE_RECAPTCHA,
})

export const acceptDisclaimer = () => ({
  type: ACCEPT_DISCLAIMER,
})

export const recaptchaLoaded = () => ({
  type: RECAPTCHA_LOADED,
})

export const selectParcel = (laiskey: string) => ({
  type: SELECT_PARCEL,
  payload: laiskey,
})

// Types

export interface RecaptchaPayload {
  recaptchaV2Code?: string | undefined
}

export type RecaptchaAction<T extends RecaptchaPayload> = PayloadAction<T>

type RecaptchaState = {
  renderCaptcha: boolean
  action?: RecaptchaAction<RecaptchaPayload>
  recaptchaLoaded: boolean
}

type DisclaimerState = {
  accepted: boolean
}

export interface MatchProps extends RouteComponentProps<MatchParams> {
}

export interface ParcelData extends LocationData {
  address: string
  lotDetails: string
  planningApps?: PlanningAppData[]
  landArea: number
  laisKey: string
  parcelId: string
}

interface MatchParams {
  laisKey: string
  coordinates: string
}

// Reducers

export const recaptchaReducer = (state: RecaptchaState = { renderCaptcha: false, recaptchaLoaded: false }, {
  type,
  payload,
}: PayloadAction<RecaptchaAction<RecaptchaPayload>>) => {
  if (type === FORCE_RECAPTCHA && !state.renderCaptcha) {
    state = {
      ...state,
      renderCaptcha: true,
      action: payload,
    }
  } else if (type === HIDE_RECAPTCHA) {
    state = {
      ...state,
      renderCaptcha: false,
      action: undefined,
    }
  } else if (type === RECAPTCHA_LOADED) {
    state = {
      ...state,
      recaptchaLoaded: true,
    }
  }

  return state
}

export const disclaimerReducer = (state: DisclaimerState = { accepted: false }, { type }: Action) => {
  if (type === ACCEPT_DISCLAIMER) {
    state = { ...state, accepted: true }
  }
  return state
}

export const selectedParcelReducer = (laiskey: string = '', { type, payload }: PayloadAction<string>) => {
  if (type === SELECT_PARCEL || type === SELECT_AP_PARCEL) {
    return payload
  }
  return laiskey
}
